/**
 * Primary UI font — Source Sans Pro is loaded in public/index.html (Google Fonts).
 * Use this string in MUI `sx` / `style` so multi-word family names are quoted correctly in CSS.
 */
export const FONT_FAMILY_PRIMARY = "'Source Sans Pro', Arial, sans-serif";

/** Monospace stack for code / technical fields */
export const FONT_FAMILY_MONO =
  'source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace';
